import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    iconContainer: {
      fontSize: '0.875rem',
    },
  })
);
